import { useMemo } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

import { fromPathnameToIsWeek } from 'bl/pathname.bl';
import navFor from 'utils/links/navFor.util';

export const useNavFor = (...tags) => {
  const history = useHistory();

  tags.unshift('useNavFor()');

  return useMemo(() => navFor(tags, { history }), [history, tags]);
};

export const useNavIsWeek = () => {
  const routerMatch = useRouteMatch();
  return fromPathnameToIsWeek(routerMatch?.path);
};
